import useAxiosInterceptor from '../interceptor';
import { copyTextBank } from '../apiServices/constants';

const { getCPTCodesDescription } = copyTextBank;

class CopyTextBankService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getCPTCodesDescription = (CPTCode: string) => {
    return this.axiosInstance.get(getCPTCodesDescription, {
      params: {
        code: CPTCode,
      },
    });
  };
}

const copyTextBankService = new CopyTextBankService();

Object.freeze(copyTextBankService);

export default copyTextBankService;
